import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
const Profile = () => {
   const myName = "Jordan Alba Reed"
   return (
      <>
         <Card className='profile-card'>
            <Card.Body>
               <div className='image text-center'>
                  <img src={'assets/img/headShot.png'} alt='Head Shot' />
               </div>
               <Card.Title as="h3">
                  {myName}
               </Card.Title>
               <Card.Text>
                  A Passionate <span>Fullstack &amp; Game Developer</span>🖥️ having <span>4 years</span> of experience through the Boise State University <a href="https://www.boisestate.edu/gimm/">GIMM</a> program.
               </Card.Text>
               <Button>
                  Email
               </Button>
               <Button variant="secondary">
                  Github
               </Button>
            </Card.Body>
         </Card>
     </>
   )
 }

 export default Profile;